import { Badge, Breadcrumb, Col, Divider, Row, Spin, Typography } from "antd"
import { doc, getDoc } from "firebase/firestore"
import { useEffect, useState } from "react"
import { Link as Redirect, useLocation } from "react-router-dom"
import OrderDescription from "../../../components/Designer/DesignerOrderDetail/OrderDescription"
import OrderProductDetails from "../../../components/Designer/DesignerOrderDetail/OrderProductDetails"
import { db } from "../../../firebase/config"
import UpdateOrder from "../../../components/Designer/DesignerOrderDetail/UpdateOrder"

const { Title } = Typography

export default function ActiveOrderView() {
  //data that contains the order data
  const [orderData, setOrderData] = useState(null)

  //data that is a duplicate, for checking if any changes were made
  const [oldOrderData, setOldOrderData] = useState(null)
  const [loading, setLoading] = useState(false)

  //use location to get the state for the link
  const location = useLocation()

  const data = location.state

  useEffect(() => {
    setLoading(true)
    if (typeof data === "string") {
      const docRef = doc(db, "orders", data)
      getDoc(docRef)
        .then((docSnap) => {
          if (docSnap.exists()) {
            setOrderData(docSnap.data())
            setOldOrderData(docSnap.data())
          } else {
            // doc.data() will be undefined in this case
            alert("No such document!")
          }
        })
        .then(() => {
          setLoading(false)
        })
    } else if (typeof data === "object") {
      setOrderData(data)
      setOldOrderData(data)
      setLoading(false)
      console.log("123" + data)
    } else {
      console.log("myState is neither a string nor an object")
      setLoading(false)
    }
  }, [data])

  const breadcrumbItems = [
    {
      title: <Redirect to="/">Dashboard</Redirect>,
    },
    {
      title: <Redirect to="/designer/order-list">Order List</Redirect>,
    },
    {
      title: "Active Order",
    },
  ]

  if (loading && !data) {
    return (
      <>
        <Spin />
      </>
    )
  }

  const getCorrectLayout = () => {
    return (
      <>
        <Col span={24}>
          <OrderDescription loading={loading} data={orderData} />
        </Col>
        <Col span={24}>
          <OrderProductDetails
            loading={loading}
            setOrderData={setOrderData}
            orderData={orderData}
          />
        </Col>
        <Col span={24}>
          {/* sends the loading, oldOrderData(data for verification if there are changes) 
               and orderData */}

          <UpdateOrder loading={loading} oldOrderData={oldOrderData} data={orderData} />
        </Col>
      </>
    )
  }

  return (
    <>
      <Breadcrumb items={breadcrumbItems} />

      <Row gutter={[15, 15]}>
        <Col span={24}>
          <div style={{ paddingLeft: 15, paddingTop: 15 }}>
            <Title level={3}>
              <Badge status="processing" style={{ fontSize: 25 }} />
              <Divider type="vertical" />
              Active Order
            </Title>
          </div>
        </Col>
        {getCorrectLayout()}
      </Row>
    </>
  )
}
